{
  "tab": "Auditoria",
  "title": "Registro de Auditoria Administrativa",
  "empty": "Nenhum registro de auditoria para exibir",
  "columns": {
    "at": "Em",
    "actor": "Autor",
    "feature": "Recurso",
    "action": "Ação",
    "target": "Alvo",
    "scope": "Organização / Local",
    "outcome": "Resultado"
  },
  "filters": {
    "actor": "E-mail do autor",
    "actorPlaceholder": "Qualquer autor",
    "target": "Alvo",
    "targetPlaceholder": "Id, e-mail ou nome",
    "feature": "Recurso",
    "featurePlaceholder": "Todos os recursos",
    "dateRange": "Período",
    "dateRangePlaceholder": "Todas as datas"
  },
  "features": {
    "administration": "Administração",
    "management": "Gerenciamento",
    "gmp-lamb-data-analysis": "Análise de Dados GMP Cordeiro",
    "gmp-lamb-bookings": "Reservas GMP Cordeiro",
    "camera-aus-meat-omm": "MEQ Camera — AUS-MEAT OMM",
    "camera-mb-gateway-movement": "MEQ Camera — Movimentação de Gateways MB",
    "dao-producers": "Visão Geral de Análise de Dados — Produtores"
  },
  "outcomes": {
    "applied": "Aplicado",
    "refused": "Recusado"
  },
  "actor": {
    "super-admin": "Super Administrador",
    "super-user": "Super Usuário",
    "admin": "Administrador",
    "user": "Usuário",
    "unknown": "Autor desconhecido"
  },
  "detail": {
    "field": "Campo",
    "before": "Antes",
    "after": "Depois",
    "requestId": "Id da requisição",
    "beforeTruncated": "O estado anterior era grande demais para ser guardado ({{kilobytes}} KB)",
    "afterTruncated": "O estado posterior era grande demais para ser guardado ({{kilobytes}} KB)",
    "noChangedFields": "Nenhum campo alterado registrado"
  },
  "recentChanges": {
    "title": "Alterações recentes",
    "showMore": "Mostrar mais",
    "empty": "Nenhuma alteração registrada para esta organização ainda"
  }
}
